import React from "react";

export default function Header() {
  return (
    <div>
      <div className="header">ATTENDANCE PORTAL</div>
    </div>
  );
}
